export const FormatNumber = ( num:number, places:number, withComma?:boolean ) => {
	if (withComma) {
		return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
	}
	return parseFloat(num.toString()).toFixed(places)
};


// WEBPACK FOOTER //
// ./src/components/utils/FormatNumber.ts